var $970538d6c6329605$exports = {};
$970538d6c6329605$exports = {
    "Clear search": `Keres\xe9s t\xf6rl\xe9se`
};


export {$970538d6c6329605$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
